export const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const addDays = (date, days) => {
  const next = new Date(date);
  next.setDate(next.getDate() + days);

  return next;
};

export const isSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();

export const formatTime = (date, locale) => date.toLocaleTimeString(locale, { hour: 'numeric', minute: '2-digit' });
